import { GatsbyLink } from "@mgdx-libs/link";
import { cx } from "cva";

import { LinkProps, variants } from ".";

export const Link = ({ className, appearance, widthType, align, fontSize, ...props }: LinkProps) => {
  return <GatsbyLink className={cx(className, variants({ appearance, widthType, align, fontSize }))} {...props} />;
};
